import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { Button } from "antd";
import { Loader } from "@vds/loaders";
import { Input } from "@vds/inputs";
import axios from "axios";
import { ReactComponent as Successcheckmark } from "../../assets/alternate-checkmark.svg";
import { validateEmail } from "../../global/utility/Utils";
import { forgotPasswordEndPoint } from "../../configuration";
import { resetOrForgotPasswordApi } from "../../pages/UserGroups/userGroupsService";

const ForgotPassword = () => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(false);

  const [decodedToken, setDecodedToken] = useState(null);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [userName, setUserName] = useState("");

  const [password, setPassword] = useState("");

  const location = useLocation();

  const getQueryParam = (param) => {
    const params = new URLSearchParams(location.search);
    return params.get(param);
  };
  const token = getQueryParam("token");
  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded);
        const { UserID } = decoded?.recovery;
      } catch (error) {
        console.error("Invalid token:", error);
      }
    } else {
      console.error("Invalid token:", error);
    }
  }, [location]);

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setInvalidEmail(!validateEmail(newEmail));
    setUserName(newEmail);
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    const payload = {
      email: userName,
      clientid: "5GVisionInsight",
    };
    const response = await resetOrForgotPasswordApi(
      payload,
      token,
      forgotPasswordEndPoint()
    );
    if (response?.status === 200) {
      setSuccessMessage(true);
    }
    // } catch (error) {
    //     console.log("Error in accept invite user flow", error);
    //     setError(error.message);
    //     setSuccessMessage(false);
    // } finally {
    setLoading(false);
    // }
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "864px",
            height: "1170px",
            backgroundColor: "#000000",
            display: "flex",
          }}
        >
          <div
            style={{
              marginTop: "432px",
              display: "flex",
              marginLeft: "192px",
            }}
          >
            <h4
              style={{
                color: "#FFFFFF",
                fontWeight: "700px",
                fontSize: "44.2px",
                lineHeight: "50px",
              }}
            >
              {""}
              5G Video Insights
            </h4>
          </div>
        </div>
        {successMessage ? (
          <div
            style={{
              marginLeft: "200px",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <br />
            <br />
            <div
              style={{
                display: "inline-block",
                textAlign: "left",
                width: "100%",
              }}
            >
              <h1
                className="text-center font-face-vzb"
                style={{
                  fontWeight: "300",
                  fontSize: "32px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Successcheckmark
                  style={{ width: "36px", height: "36px", marginRight: "10px" }}
                />
                Password reset email sent
              </h1>
              <p
                style={{
                  marginTop: "35px",
                  fontSize: "16px",
                  fontWeight: "400",
                }}
              >
                We have sent a password reset link to the email
                <br />
                provided. Please check your mail and follow the
                <br />
                instructions provided.
              </p>
            </div>
            <br />
          </div>
        ) : (
          <div
            style={{
              marginLeft: "200px",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <br />
            <br />
            <div style={{ display: "inline-block", textAlign: "left" }}>
              <h1
                className="text-center font-face-vzb"
                style={{ fontWeight: "300", fontSize: "32px" }}
              >
                Let’s reset your password
              </h1>
              <p
                style={{
                  marginTop: "35px",
                  fontSize: "16px",
                  fontWeight: "400",
                }}
              >
                Enter your email to begin resetting your password.
              </p>
            </div>
            <br />
            <form className="sasp_login_form" style={{ textAlign: "center" }}>
              <div
                style={{
                  marginTop: "10px",
                  marginLeft: "-50px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ marginBottom: "24px" }}>
                  <Input
                    type="text"
                    width="342px"
                    label="Email"
                    readOnly={false}
                    required={true}
                    disabled={false}
                    error={invalidEmail}
                    errorText="Enter a valid Email."
                    onChange={handleEmailChange}
                  />
                </div>
                <div>
                  <Button
                    type="primary"
                    className="login-pageButton"
                    // onClick={handleContinueClick}
                    onClick={handleSubmit}
                    //disabled={invalidEmail || loading}
                  >
                    {/* {loading ? <Loader /> : "Continue"} */}
                    Continue
                  </Button>
                </div>
              </div>
              <br />
              <br />
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  marginLeft: "-50px",
                }}
              >
                By continuing, you agree to the{" "}
                <span>
                  <a
                    href="https://www.verizonenterprise.com/terms?adobe_mc=MCMID%3D79489331358806469974203692604025620162%7CMCORGID%3D7ED836675AB3A4860A495CAD%2540AdobeOrg%7CTS%3D1662453824"
                    className="tcFooterLink"
                  >
                    Terms & Conditions
                  </a>
                </span>{" "}
                and Privacy policy.
              </p>
            </form>
            {error && <p style={{ color: "red" }}>{error}</p>}
          </div>
        )}
      </div>
    </>
  );
};

export default ForgotPassword;
